<template>
  <div>
    <el-dialog v-model="dialogVisible" :width="dialogWidth" class="login-dialog" :before-close="closeLogin">
      <div style="display: flex; flex-direction: column; align-items: center;">
        <div class="text-[20px] text-[#222529] font-semibold leading-snug justify-center">
          用户登陆</div>
        <div class="text-[12px] mt-[10px] justify-center">
          仅用于身份识别，本站不会获取您的任何隐私信息~
        </div>
        <div class="mx-auto mt-[20px] justify-center">
          <el-form ref="loginFormRef" :model="ruleForm" class="w-[235px]">
            <el-form-item prop="email">
              <!-- DesignChange: 登录邮箱placeholder -->
              <el-input type="email" placeholder="请输入邮箱" autocomplete="off" :prefix-icon="Message"
                v-model="ruleForm.email" size="large" class="input-rounded" />
            </el-form-item>
            <el-form-item prop="password">
              <!-- DesignChange: 登录密码placeholder -->
              <el-input type="password" placeholder="请输入密码" autocomplete="off" :prefix-icon="Lock"
                v-model="ruleForm.password" show-password size="large" class="input-rounded" />
            </el-form-item>
            <el-form-item class="captcha">
              <div style="display: flex; align-items: center;">
                <el-input style="width: 120px; flex: 1" v-model="ruleForm.captcha" size="large" class="input-captcha" />
                <div
                  class="h-full min-h-40px flex items-center flex-1 border-l-0 border-t-1px border-b-1px border-r-1px border-solid border-gray-300 cursor-pointer rounded-rt-8px rounded-rb-8px rounded-lt-0 rounded-lb-0"
                  @click="getOauthCaptcha">
                  <img loading="lazy" :src="loginCaptchaImage" alt="captcha" v-loading="loginCaptchaLoading"
                    class="rounded-rt-8px rounded-rb-8px rounded-lt-0 rounded-lb-0" />
                </div>
              </div>
            </el-form-item>
            <el-button class="w-[230px]" type="primary" @click="handleLogin" color="#2a66ff" size="large"
              style="border-radius: 8px">登录</el-button>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from "vue";
import { imageCaptcha, oauthLogin, designLoginVerification } from "@/api/oauth";
import { ElMessage } from "element-plus";
import { useUserStore } from "@/stores/user";

import { Message, Lock } from "@element-plus/icons-vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute()
const userStore = useUserStore();
const dialogVisible = ref(false);
const windowWidth = ref(window.innerWidth);
const dialogWidth = computed(() =>
  windowWidth.value * 0.35 > 500 ? windowWidth.value * 0.35 : 500
);
const ruleForm = ref({
  email: "",
  password: "",
  captcha: "",
});
const loginCaptchaImage = ref("");
const loginCaptchaLoading = ref(false);
const getOauthCaptcha = async () => {
  loginCaptchaLoading.value = true;
  const result = await imageCaptcha();
  if (result.data.code === 200) {
    loginCaptchaImage.value = "data:image/png;base64," + result.data.data.image;
    loginCaptchaLoading.value = false;
  }
};
const closeLogin = () => {
  dialogVisible.value = false;
};
onMounted(() => {
  if (route.query.key) {
    LoginVerification()
  } else {
    dialogVisible.value = true;
  }
  getOauthCaptcha();
});
const handleLogin = async () => {
  const result = await oauthLogin(ruleForm.value);
  if (result.data.code === 200) {
    const userResult = result.data.data;
    userStore.setAuthData(userResult);
    ElMessage.success("登录成功");
    dialogVisible.value = false;
    router.push(
      {
        path: "/editor",
        query: { mode: 'user', id: route.query.id, create_tag: route.query['create_tag'] == '1' ? 1 : '', order_no: route.query['order_no'], increment_id: route.query.increment_id, now_state: route.query.now_state }
      }
    );
  }
};
const LoginVerification = async () => {
  try {
    const result = await designLoginVerification({ key: route.query.key })
    if (result.data.code == 200) {
      const userResult = result.data.data;
      userStore.setAuthData(userResult);
      dialogVisible.value = false;
      router.push({
        path: `/editor`,
        query: { mode: 'user', id: route.query.id, create_tag: route.query['create_tag'] == '1' ? 1 : '', order_no: route.query['order_no'], increment_id: route.query.increment_id, now_state: route.query.now_state }
      })
    }
  } catch (error) {
    dialogVisible.value = true;
  }
}
</script>

<style scoped lang="scss"></style>
